import { createSlice } from "@reduxjs/toolkit";

export const expandableCardReducer = createSlice({
    name: "expandableCard",
    initialState: {},
    reducers: {
        setOpen: (state, action) => {
            if (state[action.payload]) {
                state[action.payload] = false;
            }
            else {
                state[action.payload] = true;
            }
        }

    },
});

// Action creators are generated for each case reducer function
export const { setOpen } = expandableCardReducer.actions;

export default expandableCardReducer.reducer;
